import { useTranslation } from "react-i18next";
import { useFetch } from "../../../../hooks/api";
import { Row, Col, Table } from "react-bootstrap";
import moment from "moment";
import Loading from "../../../core/blocks/Loading";
import { formatCurrency } from "../../../../utils/formatNumber";
import { snakeCaseToSentenceCase } from "../../../../utils/formatText";

const BiddingProgramLog = ({ programId, targetId, targetType = "keyword", marketPlace, title }) => {
  const { t } = useTranslation(["programs"]);
  const logQueryFilters = {
    [`adv_${targetType}`]: targetId,
  };

  const { data, isLoading } = useFetch(
    ["program_logs", programId, targetId, targetType],
    `/programlogs/advertised_${targetType}s/`,
    logQueryFilters,
    { select: (data) => data?.data?.results ?? [] },
  );
  return (
    <>
      <Row className="pt-5">
        <Col>
          <div className="pb-3">
            <span className="fs-4 fw-bold">{t(($) => $.programs.log["{title} Logs"], { title })}</span>
          </div>
        </Col>
      </Row>
      <Row className="pb-3">
        <Col>
          {isLoading && <Loading height={"300px"} fullPage={false} />}
          {!isLoading && (
            <Table striped bordered>
              <thead>
                <tr>
                  <th>{t(($) => $.programs.log.Time)}</th>
                  <th>{t(($) => $.programs.log.Program)}</th>
                  <th>{t(($) => $.programs.log.Action)}</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((log, i) => {
                  const action = log?.action?.[0];
                  return (
                    <tr key={i}>
                      <td>{moment(log.ts).format("YYYY-MM-DD HH:mm:ss")}</td>
                      <td>
                        {log?.program?.name} ({log?.program?.id})
                      </td>
                      <td>
                        {action?.function !== undefined ?
                          <div>
                            <span className="fw-bold">{snakeCaseToSentenceCase(action.function)}</span>
                            :&nbsp;
                            <span className="fw-light">
                              {t(($) => $.programs.log["New: {amount}"], {
                                amount: formatCurrency(action.next_bid, {
                                  marketPlace: marketPlace.marketPlace,
                                }),
                              })}
                            </span>
                            &nbsp; - &nbsp;
                            <span className="fw-light">
                              {t(($) => $.programs.log["Prev: {amount}"], {
                                amount: formatCurrency(action.current_bid, {
                                  marketPlace: marketPlace.marketPlace,
                                }),
                              })}
                            </span>
                          </div>
                        : t(($) => $.programs.log["N/A"])}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </>
  );
};

export default BiddingProgramLog;
